const getAprovarError = () =>
  `<span>Classificação Inválida para aprovar</span><br>`;

const getAprovarSuccess = (productCode: string) =>
  `<span>Part Number ${productCode} <strong>aprovado</strong> com sucesso.</span><br>`;

const getAprovarBodyText = () =>
  `<span>Você deseja aprovar a classificação: </span>`;

const getDeleteBodyText = () =>
  `<span>Você deseja excluir esse Laudo Pendente? </span>`;

const getCorrigirBodyText = () =>
  `<span>Você deseja aprovar esse Laudo Técnico?? </span>`;

const getDeleteGeneric = (text: string) =>
  `<span>${text}</span>`;

const getAprovarBodyDescription = (productCode: any, ncmCode: any) =>
  `<span>${productCode} para a NCM ${ncmCode}?</span>`;

const getComentarPrompt = () =>
  `<span>Deseja inserir um comentário?</span><br>`;

const getComentarError = () =>
  `<span>Classificação Inválida para comentar</span><br>`;

const getComentarSuccess = (productCode: string) =>
  `<span>Part Number ${productCode} <strong>comentado</strong> com sucesso.</span><br>`;

const getCorrigirPrompt = () =>
  `<span>Deseja corrigir a classificação?</span><br>`;

const getNaladiPrompt = () => `<span>Deseja corrigir o NALADI?</span><br>`;

const getCorrigirError = () =>
  `<span>Classificação Inválida para corrigir</span><br>`;

const getCorrigirSuccess = (productCode: any) =>
  `<span>Part Number ${productCode} <strong>corrigido</strong> com sucesso.</span><br>`;

const getNaladiSuccess = () =>
  `<span> <strong>Naladi corrigido com sucesso. </strong></span><br>`;

const bodyTextTitle = () =>
  `<span>Você deseja retomar sua sessão de onde parou?</span><br><br>`;

const bodyText = (modalProduct: string, modalDesc: string) =>
  `<p class="paragraph"> Classificação: ${modalProduct} - ${modalDesc}
</p>`;

const bodyTexts = () =>
  `<p class="paragraph_custom"><strong class="sessao"></strong>Ao clicar em __Sim__, suas informações preenchidas até o momento serão salvas e você será deslogado do sistema.
</p>`;

const bodyTextErros = (httpStatus: number) => {
  if (httpStatus === 422) {
    return `<strong>PN informado possui classificação muito recente.</strong>
<p class="paragraph">Deseja __trocar__ o PN ou __continuar__ sem um PN Similar?</p>`;
  } else if (httpStatus === 409 || httpStatus === 404) {
    return `<strong>O PN favorito informado não foi encontrado.</strong>
<p class="paragraph">Deseja __corrigir__ o PN ou __continuar__ sem um PN Similar?</p>`;
  } else if (httpStatus === 500) {
    return `<strong>O PN similar favorito informado não foi encontrado.</strong>
<p class="paragraph">Deseja __corrigir__ o PN ou __continuar__ sem um PN Similar?</p>`;
  } else {
    return "";
  }
};  

const DEFAULT_RESPONSIBILITY_GROUP_ERROR = "Erro interno no servidor.";

type NotificationRule = {
  pattern: RegExp;
  build: (match: RegExpExecArray) => string;
};

const RESPONSIBILITY_GROUP_ERROR_RULES: NotificationRule[] = [
  {
    pattern: /^User does not have permission!?$/i,
    build: () => "O usuário não tem permissão!",
  },
  {
    pattern: /^Responsibility group with the same name already exists!?$/i,
    build: () => "Já existe um grupo de responsabilidade com o mesmo nome!",
  },
  {
    pattern: /^Mockup user not found!?$/i,
    build: () => "Usuário mockup não encontrado!",
  },
  {
    pattern: /^Responsibility group not found\.?$/i,
    build: () => "Grupo de responsabilidade não encontrado.",
  },
  {
    pattern: /^Duplicated rule field:([^\r\n]+)$/i,
    build: (match) => `Campo de regra duplicado: ${match[1].trim()}`,
  },
  {
    pattern: /^Required rule field is empty:([^\r\n]+)$/i,
    build: (match) => `Campo de regra obrigatório vazio: ${match[1].trim()}`,
  },
  {
    pattern: /^Rules conflict with responsibility group:([^\r\n]+)$/i,
    build: (match) =>
      `As regras entram em conflito com o grupo de responsabilidade: ${match[1].trim()}`,
  },
  {
    pattern: /^Unsupported responsibility group field:([^\r\n]+)$/i,
    build: (match) =>
      `Campo de grupo de responsabilidade não suportado: ${match[1].trim()}`,
  },
  {
    pattern: /^must not be null$/i,
    build: () => "Não pode ser nulo.",
  },
  {
    pattern: /^must not be blank$/i,
    build: () => "Não pode ficar em branco.",
  },
  {
    pattern: /^Responsibility group administrator not found!?$/i,
    build: () => "Administrador do grupo de responsabilidade não encontrado!",
  },
  {
    pattern: /^User is already a participant of this responsibility group!?$/i,
    build: () => "O usuário já é participante deste grupo de responsabilidade!",
  },
  {
    pattern: /^Responsibility group participant not found\.?$/i,
    build: () => "Participante do grupo de responsabilidade não encontrado.",
  },
  {
    pattern: /^The administrator cannot be removed from the group!?$/i,
    build: () => "O administrador não pode ser removido do grupo!",
  },
  {
    pattern: /^User is already the administrator of this responsibility group!?$/i,
    build: () => "O usuário já é o administrador deste grupo de responsabilidade!",
  },
  {
    pattern: /^Erro interno no servidor\.?$/i,
    build: () => DEFAULT_RESPONSIBILITY_GROUP_ERROR,
  },
];

const resolveResponsibilityGroupError = (
  errorMessage: string | null | undefined,
) => {
  const normalizedMessage = errorMessage?.trim();

  if (!normalizedMessage) return DEFAULT_RESPONSIBILITY_GROUP_ERROR;

  for (const rule of RESPONSIBILITY_GROUP_ERROR_RULES) {
    const match = rule.pattern.exec(normalizedMessage);

    if (match) return rule.build(match);
  }

  return DEFAULT_RESPONSIBILITY_GROUP_ERROR;
};

const getResetSuccess = (partNumber: string) =>
  `<span>O item <strong>${partNumber}</strong> foi resetado com sucesso.</span><br>`;

const getResetError = (partNumber: string, sessionIdMissing: boolean = false) =>
  `<span>${sessionIdMissing ? "<strong>Sessão não encontrada!</strong>" : ""} O item <strong>${partNumber}</strong> não pôde ser resetado.</span><br>`;

const getArquivoInvalidoError = () =>
  `<span><strong>Erro ao carregar o arquivo!</strong> Por favor insira um arquivo válido.</span><br>`;

const getCreateGroupError = (errorMessage?: string) =>
  resolveResponsibilityGroupError(errorMessage);

const getSaveGroupRulesError = (errorMessage?: string) =>
  resolveResponsibilityGroupError(errorMessage);

const getDeleteGroupError = (errorMessage?: string) =>
  resolveResponsibilityGroupError(errorMessage);

const getCreateGroupParticipantError = (errorMessage?: string) =>
  resolveResponsibilityGroupError(errorMessage);

const getDeleteGroupParticipantError = (errorMessage?: string) =>
  resolveResponsibilityGroupError(errorMessage);

const getSetGroupAdministratorError = (errorMessage?: string) =>
  resolveResponsibilityGroupError(errorMessage);

const Textnotifications = {
  getAprovarError,
  getAprovarSuccess,
  getAprovarBodyText,
  getAprovarBodyDescription,
  getComentarPrompt,
  getComentarError,
  getComentarSuccess,
  getCorrigirPrompt,
  getNaladiSuccess,
  getNaladiPrompt,
  getCorrigirError,
  getCorrigirSuccess,
  getDeleteBodyText,
  bodyTextTitle,
  bodyText,
  bodyTexts,
  bodyTextErros,
  getCorrigirBodyText,
  getDeleteGeneric,
  getResetSuccess,
  getResetError,
  getArquivoInvalidoError,
  getCreateGroupError,
  getSaveGroupRulesError,
  getDeleteGroupError,
  getCreateGroupParticipantError,
  getDeleteGroupParticipantError,
  getSetGroupAdministratorError,
};

export default Textnotifications;
